(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simurg-v2-authors"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sv3-scroller')){
customElements.define('sv3-scroller',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;const track=this.querySelector('[data-sv3-track]');const buttons=this.querySelectorAll('[data-sv3-dir]');if(!track)return;
 const update=()=>{const max=track.scrollWidth-track.clientWidth;buttons.forEach(b=>{b.disabled=Number(b.dataset.sv3Dir)<0?track.scrollLeft<2:track.scrollLeft>=max-2;});this.classList.toggle('is-static',max<3);};
 buttons.forEach(b=>b.addEventListener('click',()=>track.scrollBy({left:Number(b.dataset.sv3Dir)*(track.firstElementChild.getBoundingClientRect().width+20),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})));
 track.addEventListener('scroll',update,{passive:true});this.observer=new ResizeObserver(update);this.observer.observe(track);update();}
 disconnectedCallback(){this.observer?.disconnect();this.ready=false;}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simurg-v2-category-nav"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sv3-scroller')){
customElements.define('sv3-scroller',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;const track=this.querySelector('[data-sv3-track]');const buttons=this.querySelectorAll('[data-sv3-dir]');if(!track)return;
 const update=()=>{const max=track.scrollWidth-track.clientWidth;buttons.forEach(b=>{b.disabled=Number(b.dataset.sv3Dir)<0?track.scrollLeft<2:track.scrollLeft>=max-2;});this.classList.toggle('is-static',max<3);};
 buttons.forEach(b=>b.addEventListener('click',()=>track.scrollBy({left:Number(b.dataset.sv3Dir)*(track.firstElementChild.getBoundingClientRect().width+20),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})));
 track.addEventListener('scroll',update,{passive:true});this.observer=new ResizeObserver(update);this.observer.observe(track);update();}
 disconnectedCallback(){this.observer?.disconnect();this.ready=false;}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simurg-v2-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('simurg-book-hero')){
customElements.define('simurg-book-hero',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;this.index=0;
this.books=[...this.querySelectorAll('[data-book]')];this.panels=[...this.querySelectorAll('[data-panel]')];
this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.reduced.matches;this.hovered=false;this.focused=false;
this.abort=new AbortController();const options={signal:this.abort.signal};
this.books.forEach((book,i)=>{
book.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')this.show(i)},options);
book.addEventListener('focus',()=>this.show(i),options);
});
this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){this.hovered=true;this.schedule()}},options);
this.addEventListener('pointerleave',()=>{this.hovered=false;this.schedule()},options);
this.addEventListener('focusin',()=>{this.focused=true;this.schedule()},options);
this.addEventListener('focusout',()=>{queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.schedule()})},options);
this.querySelector('[data-prev]').addEventListener('click',()=>this.show(this.index-1),options);
this.querySelector('[data-next]').addEventListener('click',()=>this.show(this.index+1),options);
this.pauseButton=this.querySelector('[data-pause]');
this.pauseButton.addEventListener('click',()=>{this.paused=!this.paused;this.label();this.schedule()},options);
document.addEventListener('visibilitychange',()=>this.schedule(),options);
this.reduced.addEventListener('change',()=>{this.paused=this.reduced.matches;this.label();this.schedule()},options);
this.addEventListener('shopify:block:select',e=>{const i=this.panels.indexOf(e.target.closest('[data-panel]'));if(i>=0){this.show(i);this.paused=true;this.label();this.schedule()}},options);
this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule()});this.observer.observe(this);
this.label();
}
label(){this.pauseButton.textContent=this.paused?this.pauseButton.dataset.playLabel:this.pauseButton.dataset.pauseLabel;this.pauseButton.setAttribute('aria-pressed',String(this.paused))}
show(i){if(!this.books.length)return;this.index=(i+this.books.length)%this.books.length;this.books.forEach((b,n)=>{b.classList.toggle('is-active',n===this.index)});this.panels.forEach((p,n)=>{p.hidden=n!==this.index;p.inert=n!==this.index});this.querySelector('[data-position]').textContent=(this.index+1)+' / '+this.books.length;const shelf=this.querySelector('.sb4__shelf'),book=this.books[this.index];const a=book.getBoundingClientRect(),b=shelf.getBoundingClientRect();if(a.left<b.left+8||a.right>b.right-8)shelf.scrollTo({left:shelf.scrollLeft+a.left-b.left-(shelf.clientWidth-a.width)/2,behavior:this.reduced.matches?'instant':'smooth'})}
schedule(){clearTimeout(this.timer);if(this.paused||this.hovered||this.focused||document.hidden||!this.visible||this.books.length<2)return;this.timer=setTimeout(()=>{this.show(this.index+1);this.schedule()},Number(this.dataset.delay)||6500)}
disconnectedCallback(){clearTimeout(this.timer);this.observer?.disconnect();this.abort?.abort();this.ready=false}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simurg-v2-weekly-bestsellers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBestsellers(root) {
      root.querySelectorAll('[data-bestsellers]').forEach(function (section) {
        if (section.dataset.ready === 'true') return;
        section.dataset.ready = 'true';

        var track = section.querySelector('[data-bestsellers-track]');
        var cards = Array.from(section.querySelectorAll('[data-bestseller-card]'));
        var prev = section.querySelector('[data-bestsellers-prev]');
        var next = section.querySelector('[data-bestsellers-next]');
        if (!track || cards.length === 0 || !prev || !next) return;

        var activeIndex = Math.min(2, cards.length - 1);

        function setActive(index, shouldScroll) {
          activeIndex = Math.max(0, Math.min(index, cards.length - 1));
          cards.forEach(function (card, cardIndex) {
            card.classList.toggle('is-active', cardIndex === activeIndex);
          });
          prev.disabled = activeIndex === 0;
          next.disabled = activeIndex === cards.length - 1;
          if (shouldScroll) track.scrollTo({left: track.scrollLeft + cards[activeIndex].getBoundingClientRect().left + cards[activeIndex].getBoundingClientRect().width / 2 - track.getBoundingClientRect().left - track.clientWidth / 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        }

        cards.forEach(function (card, index) {
          card.addEventListener('focus', function () { setActive(index, false); });
          card.addEventListener('mouseenter', function () { setActive(index, false); });
        });

        prev.addEventListener('click', function () { setActive(activeIndex - 1, true); });
        next.addEventListener('click', function () { setActive(activeIndex + 1, true); });

        var scrollTimer;
        track.addEventListener('scroll', function () {
          window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(function () {
            var trackCenter = track.getBoundingClientRect().left + (track.clientWidth / 2);
            var nearestIndex = 0;
            var nearestDistance = Infinity;
            cards.forEach(function (card, index) {
              var rect = card.getBoundingClientRect();
              var cardCenter = rect.left + (rect.width / 2);
              var distance = Math.abs(trackCenter - cardCenter);
              if (distance < nearestDistance) {
                nearestDistance = distance;
                nearestIndex = index;
              }
            });
            setActive(nearestIndex, false);
          }, 90);
        });

        window.requestAnimationFrame(function () { setActive(activeIndex, true); });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initBestsellers(document); });
    } else {
      initBestsellers(document);
    }

    document.addEventListener('shopify:section:load', function (event) { initBestsellers(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yazarlar-grid"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initPopularSlider(slider){
    if(!slider||slider.dataset.sliderReady==='true')return;
    slider.dataset.sliderReady='true';
    const track=slider.querySelector('[data-popular-track]');
    const prev=slider.querySelector('[data-popular-prev]');
    const next=slider.querySelector('[data-popular-next]');
    if(!track||!prev||!next)return;

    function updateNavigation(){
      const maxScroll=track.scrollWidth-track.clientWidth;
      const hasOverflow=maxScroll>4;
      slider.classList.toggle('is-static',!hasOverflow);
      if(!hasOverflow){prev.disabled=true;next.disabled=true;return;}
      prev.disabled=track.scrollLeft<=4;
      next.disabled=track.scrollLeft>=maxScroll-4;
    }

    function getScrollStep(){
      const card=track.querySelector('.popular-author');
      if(!card)return track.clientWidth*.8;
      const styles=window.getComputedStyle(track);
      const gap=parseFloat(styles.columnGap)||parseFloat(styles.gap)||20;
      return card.getBoundingClientRect().width+gap;
    }

    prev.addEventListener('click',function(){track.scrollBy({left:-getScrollStep(),behavior:'smooth'});});
    next.addEventListener('click',function(){track.scrollBy({left:getScrollStep(),behavior:'smooth'});});

    let pointerDown=false;
    let isDragging=false;
    let startX=0;
    let startY=0;
    let startScrollLeft=0;
    let activePointerId=null;
    let blockLinkClick=false;
    const DRAG_THRESHOLD=10;

    track.addEventListener('pointerdown',function(event){
      if(event.pointerType==='mouse'&&event.button!==0)return;
      if(event.pointerType!=='mouse')return;
      pointerDown=true;
      isDragging=false;
      blockLinkClick=false;
      activePointerId=event.pointerId;
      startX=event.clientX;
      startY=event.clientY;
      startScrollLeft=track.scrollLeft;
    });

    track.addEventListener('pointermove',function(event){
      if(!pointerDown)return;
      const deltaX=event.clientX-startX;
      const deltaY=event.clientY-startY;
      const distance=Math.sqrt((deltaX*deltaX)+(deltaY*deltaY));
      if(!isDragging){
        if(distance<DRAG_THRESHOLD)return;
        isDragging=true;
        blockLinkClick=true;
        track.classList.add('is-dragging');
        if(track.setPointerCapture){try{track.setPointerCapture(event.pointerId);}catch(error){}}
      }
      event.preventDefault();
      track.scrollLeft=startScrollLeft-deltaX;
    });

    function stopDragging(){
      if(!pointerDown)return;
      pointerDown=false;
      if(isDragging){
        track.classList.remove('is-dragging');
        if(activePointerId!==null&&track.releasePointerCapture&&track.hasPointerCapture){
          try{if(track.hasPointerCapture(activePointerId))track.releasePointerCapture(activePointerId);}catch(error){}
        }
      }
      isDragging=false;
      activePointerId=null;
      if(blockLinkClick){window.setTimeout(function(){blockLinkClick=false;},80);}
    }

    track.addEventListener('pointerup',stopDragging);
    track.addEventListener('pointercancel',stopDragging);

    track.addEventListener('click',function(event){
      const link=event.target.closest('[data-author-link]');
      if(!link)return;
      if(!blockLinkClick)return;
      event.preventDefault();
      event.stopPropagation();
    },true);

    track.addEventListener('dragstart',function(event){event.preventDefault();});

    let scrollFrame=null;
    track.addEventListener('scroll',function(){
      if(scrollFrame)cancelAnimationFrame(scrollFrame);
      scrollFrame=requestAnimationFrame(updateNavigation);
    });

    if('ResizeObserver' in window){
      const observer=new ResizeObserver(updateNavigation);
      observer.observe(track);
    }else{
      window.addEventListener('resize',updateNavigation);
    }

    updateNavigation();
  }

  function initAllPopularSliders(scope){
    const root=scope||document;
    root.querySelectorAll('[data-popular-slider]').forEach(initPopularSlider);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){initAllPopularSliders(document);});
  }else{
    initAllPopularSliders(document);
  }

  document.addEventListener('shopify:section:load',function(event){initAllPopularSliders(event.target);});
})();

  } catch(e) { console.error(e); }
})();
})();
